// Función simple para validar teléfono USA sin formateo automático
export const validateUSPhone = (value) => {
  if (!value) return false;
  const digits = value.replace(/\D/g, "");
  return digits.length === 10;
};

// Función simple para validar teléfono Guatemala sin formateo automático
export const validateGuatemalaPhone = (value) => {
  if (!value) return false;
  const digits = value.replace(/\D/g, "");
  return digits.length === 8;
};

// Función simple para validar montos sin formateo automático
export const validateCurrency = (value) => {
  if (!value) return false;
  const numericValue = parseFloat(value) || 0;
  return numericValue > 0;
};
